export const dcaMockData = {
  //Non-CoBrand | Banner slot
  'hpHero-mbox': {
    __typename: 'DCADynamicContentMbox',
    adData: null,
    analyticsName: null,
    bullet1: null,
    bullet2: null,
    bullet3: null,
    callToActionText1: 'Book Now',
    callToActionText2: null,
    caption: null,
    captionUrl: null,
    descriptionLong: 'Find your next weekend getaway at participating hotels and resorts',
    descriptionMedium: 'Find your next weekend getaway',
    descriptionShort: 'Find your next weekend getaway',
    destinationUrl1: 'https://www.marriott.com/offers/last-minute-hotel-deals.mi?offerid=off-160715',
    destinationUrl2: null,
    eVar48: null,
    eyebrowText: null,
    headerLong: 'Members Save 20%',
    headerMedium: 'Members Save 20%',
    headerShort: 'Members Save 20%',
    image: {
      __typename: 'DCADacImage',
      alternateDescription: 'Tulip festival at an Ottawa lake front garden',
      caption: '',
      defaultImage: false,
      imageSrc:
        '/content/dam/marriott-digital/digital-merchandising/us-canada/en_us/hero/assets/pdt-DME-Tulip-Flower-Garden-883902742377849.jpeg',
      imageUrls: {
        __typename: 'DCADacImageRendition',
        classicHorizontal: '/is/image/marriotts7prod/pdt-DME-Tulip-Flower-Garden-883902742377849:Classic-Hor',
        classicVertical: '/is/image/marriotts7prod/pdt-DME-Tulip-Flower-Garden-883902742377849:Classic-Ver',
        deviceSmall: null,
        featureHorizontal: '/is/image/marriotts7prod/pdt-DME-Tulip-Flower-Garden-883902742377849:Feature-Hor',
        featureVertical: '/is/image/marriotts7prod/pdt-DME-Tulip-Flower-Garden-883902742377849:Feature-Ver',
        flex: null,
        panoramicHorizontal: '/is/image/marriotts7prod/pdt-DME-Tulip-Flower-Garden-883902742377849:Pano-Hor',
        panoramicVertical: '/is/image/marriotts7prod/pdt-DME-Tulip-Flower-Garden-883902742377849:Pano-Ver',
        square: '/is/image/marriotts7prod/pdt-DME-Tulip-Flower-Garden-883902742377849:Square',
        standardHorizontal: '/is/image/marriotts7prod/pdt-DME-Tulip-Flower-Garden-883902742377849:Standard-Hor',
        standardVertical: '/is/image/marriotts7prod/pdt-DME-Tulip-Flower-Garden-883902742377849:Standard-Ver',
        wideHorizontal: '/is/image/marriotts7prod/pdt-DME-Tulip-Flower-Garden-883902742377849:Wide-Hor',
        wideVertical: '/is/image/marriotts7prod/pdt-DME-Tulip-Flower-Garden-883902742377849:Wide-Ver',
      },
      is360Photo: false,
      isPrimary: false,
      isPrimaryArchitectural: false,
      isPrimaryServices: false,
      isSecondaryArchitectural: false,
      isSecondaryServices: false,
      marketingCaption: '',
      roomPoolCodes: [],
      roomTypeCodes: [],
      title: 'DME Tulip Flower Garden 8',
    },
    imageAssetId:
      'L2NvbnRlbnQvZGFtL21hcnJpb3R0LWRpZ2l0YWwvZGlnaXRhbC1tZXJjaGFuZGlzaW5nL3VzLWNhbmFkYS9lbl91cy9oZXJvL2Fzc2V0cy9wZHQtRE1FLVR1bGlwLUZsb3dlci1HYXJkZW4tODgzOTAyNzQyMzc3ODQ5LmpwZWc=',
    impressionValue: 'hpHero,type=dca,msg=dca,tag=MER_GLB000761V_GLE000HDN0_GLF0016YJX',
    legalLong: null,
    legalShort: null,
    localeOfContent: 'en_US',
    logo: {
      __typename: 'DCADacImage',
      alternateDescription: 'Marriott Bonvoy Escapes Logo',
      caption: '',
      defaultImage: false,
      imageSrc:
        '/content/dam/marriott-digital/digital-merchandising/us-canada/en_us/hero/assets/pdt-Marriott-Bonvoy-Escapes-762574008876390.png',
      imageUrls: {
        __typename: 'DCADacImageRendition',
        classicHorizontal: null,
        classicVertical: null,
        deviceSmall: null,
        featureHorizontal: null,
        featureVertical: null,
        flex: null,
        panoramicHorizontal: null,
        panoramicVertical: null,
        square: null,
        standardHorizontal: null,
        standardVertical: null,
        wideHorizontal: null,
        wideVertical: null,
      },
      is360Photo: false,
      isPrimary: false,
      isPrimaryArchitectural: false,
      isPrimaryServices: false,
      isSecondaryArchitectural: false,
      isSecondaryServices: false,
      marketingCaption: '',
      roomPoolCodes: [],
      roomTypeCodes: [],
      title: 'Marriott Bonvoy Escapes',
    },
    logoAssetId:
      'L2NvbnRlbnQvZGFtL21hcnJpb3R0LWRpZ2l0YWwvZGlnaXRhbC1tZXJjaGFuZGlzaW5nL3VzLWNhbmFkYS9lbl91cy9oZXJvL2Fzc2V0cy9wZHQtTWFycmlvdHQtQm9udm95LUVzY2FwZXMtNzYyNTc0MDA4ODc2MzkwLnBuZw==',
    mathLabel1: null,
    mathLabel2: null,
    mathLabel3: null,
    mathTitle: null,
    mathType: null,
    mathValue: null,
    mboxName: 'hpHero-mbox',
    metaTags: null,
    metadata: {
      campaignId: '7017',
      countryCode: 'US',
      endDate: '2026-03-15',
      issuerCode: 'CH',
      loyaltyBar: false,
      mathOffer: false,
      merTag: 'MER_GLB000761V_GLE000HDN0_GLF0016YJX',
      offerCode: 'Required',
      prequal: false,
      rpcCode: 'TEMP',
      startDate: '2026-03-11',
      theme: 'Dark',
      title: '7017_M.com Members & Non-Members_2026_US_CAN_MBE_MAR_11_DME',
      type: 'Non-CoBrand',
    },
    promotionalTag: 'Member Exclusive',
    responseTokens: {
      'profile.offersHub': 'false',
      'activity.name': '[DCA] [Homepage] [Super Size Hero] Priority Order (M.com) RELAUNCH new UI 7/7',
      'profile.isBot': 'false',
      'geo.state': 'virginia',
      'activity.id': '127087',
      'option.name': 'OFF-201499',
      'profile.MBOPLastViewedEntityId': 'none',
      'profile.MbopRpcCode': '',
      'profile.MBOPAPOOutletLastViewedEntityId': 'none',
      'geo.ispName': 'netskope inc.',
      'profile.MbopResortsRegionParam': '',
      'profile.MBOPResortPromotionOffers': '',
      'profile.geolocationLongitude': '0',
      'profile.MbopSiteIdCode': 'US',
      'profile.MBOPLocale': '["en_US"]',
      'profile.mbopCurrentDate': '2026-03-11',
      'profile.geolocationLatitude': '0',
      'profile.MBOPOfferId': 'OFF-106896',
      'profile.MBOPResortsFrontPromotion': '',
      'offer.name': 'OFF-201499',
      'profile.propImageHVMI':
        'https://homes-and-villas.marriott.com/hvmb-pictures/40407328/0df527b8_4efe_44ca_bb8c_b4ee5ba36f0c_1721949641107.jpg',
      'profile.twoGroups': 'GroupB',
      'profile.Random_4': '1',
      'profile.cobrand_swimlane': '1',
      'profile.MBOPValidDays': '',
      'experience.name': 'WF-7017 - Exp. 3/15',
      'option.id': '377',
      'geo.mobileCarrier': 'none',
      'geo.country': 'united states',
      'profile.random_number': '47',
      'profile.activeActivities':
        '108545,108544,108547,100354,108546,108548,122893,120845,83987,124958,131106,110625,120869,120870,100397,118834,120887,79930,124999,112710,116809,102477,102476,102481,118865,118864,118867,110675,110674,118866,125010,131158,102484,118877,118878,106593,118880,106594,94315,94316,127087,110705,108657,114800,112757,108663,94330,116858,120960,129156,118919,110726,118921,118920,118922,100509,131231,108700,131228,123046,123051,123050,123053,123052,114862,123054,96432,106674,94400,121029,123079,125127,110793,129227,129226,118992,106706,129237,129236,88280,119003,110810,127196,84188,129253,104678,125171,98573,121101,127244,117007,100625,117013,110868,127259,117018,127262,112932,84263,129322,121134,104753,127280,104752,104755,121138,104754,129332,127287,127286,121142,129334,131387,121146,131390,121149,131391,131395,117058,119109,86345,127307,121162,121165,127308,121167,121169,119123,121173,115028,121177,121179,121180,129379,112994,112998,129391,113006,102772,115060,113012,113015,113018,115073,108932,125320,115083,102799,131469,86419,110995,113042,127383,115096,96664,129437,129441,129440,117152,131488,129443,94626,129442,117154,115109,131495,129444,100774,113067,113066,131502,106924,131503,131506,113075,94642,131505,84405,131511,113076,113081,131513,131522,102848,117184,131520,131526,115141,102855,131543,131545,96732,131554,131552,129507,115170,131553,109035,117226,106988,92652,131565,129525,125435,131588,131589,113161,129545,129544,129547,129546,131596,98832,131603,131606,131605,94742,115227,117274,100897,125473,131619,121376,131616,131617,107044,131626,131624,131625,119341,119343,131629,119342,119345,109105,119344,109107,109106,119349,119348,109108,117306,117312,113216,107079,107082,131662,131663,131667,131664,131665,105042,129621,129620,119383,129623,129622,127577,84569,119384,123491,129637,113255,125543,129639,119400,129640,80491,125554,121472,103042,129666,129669,129668,129670,92809,129675,129674,129677,129676,129679,129678,123540,84630,129691,117402,98972,86688,119461,119460,119463,119462,103081,115368,129708,127663,113327,127664,113337,113336,115389,119485,107201,107200,107204,105164,127695,90833,99031,99030,131802,99032,107227,99034,131806,117471,123621,131819,131816,94958,99054,123630,121585,99056,121584,99058,117496,94975,115457,101121,127747,94979,101129,109320,111377,125713,115472,123667,82709,123668,117527,99097,82713,113432,82715,113435,99098,131871,113436,131872,115499,121655,117561,121658,103229,119612,103231,103233,119617,113472,103234,105287,105286,84815,115537,95057,95056,107350,129881,86872,129883,88922,129882,129884,105311,105313,129889,129888,105312,129891,105314,129893,129892,99199,121729,105345,105344,121730,113543,131973,95115,113553,131987,113555,131996,131997,103329,129952,107427,103331,123810,103333,101289,111528,125883,132025,125884,125886,91080,109518,113620,99286,130010,111583,103396,101353,130024,113649,107506,97266,125951,105474,132106,125961,119819,121867,130061,119820,128015,130063,130062,130065,130064,121875,125971,130066,125970,99349,105492,99351,121879,99350,121883,91167,121886,115747,132134,132139,99370,119863,117814,115768,130104,113725,117825,117826,113732,111693,111695,109647,115798,130145,119909,124009,128108,115823,115822,128113,115824,128112,87155,115827,115826,128114,128117,115828,128116,128119,113783,115830,128118,113787,113786,113789,119932,132230,124040,95375,130197,105621,130199,130198,99481,130201,130200,95387,99483,130202,99485,99484,99489,130210,115881,124075,95402,119981,128172,87215,99505,111795,122043,128196,115911,115910,128201,87241,115916,128206,128209,115923,128210,128215,128217,128216,101595,128221,128220,128229,128228,128231,111846,128230,120038,128233,99561,105705,111848,128235,99562,128234,99565,128237,130285,128236,128238,99569,111856,99568,128240,130295,113912,115963,120063,107777,99584,128258,122114,124167,128265,126217,126216,124170,128271,128270,128273,120083,128274,120085,122133,109845,128276,128279,128281,122137,124184,128280,128283,124186,128285,128289,116001,128288,128291,128292,124196,128295,128294,107814,128297,128298,105773,128300,128302,128304,122160,105776,128307,107826,128306,105778,105781,128308,111927,122167,128310,128313,128312,109884,111934,124222,105793,103744,111938,111941,111940,111943,130375,111942,99656,111944,99661,124239,99667,95570,109914,109917,124252,109920,109923,109922,109925,124260,109926,109929,107880,111979,109931,124269,130414,109937,109936,120181,109940,109943,109942,109944,109947,109946,109949,109948,109950,87424,126343,122248,93583,128406,128409,114072,120218,126364,120224,107943,97705,114088,114091,97707,114090,99757,130479,99761,124339,101810,122293,103867,103872,130499,128453,110021,103878,103881,103880,118219,130511,128464,120275,130517,114132,114134,107993,122329,114136,128477,130526,101861,114148,116198,116207,108014,116208,108018,116212,116215,116216,108032,114179,118274,120324,114180,116231,114182,114184,114189,114188,93710,114190,114192,114195,114194,118290,114196,128534,114198,110105,116248,95776,116262,130605,116271,116272,106035,124466,103990,124472,130628,110154,130639,120405,128598,118360,120411,114266,128605,85597,130655,130657,128610,126569,120426,128623,108142,128622,126574,128624,108153,114296,124539,130682,116352,104068,114308,114312,116368,95891,108183,85654,130710,126614,85657,114336,87715,112293,116389,87716,112292,112295,112294,110249,110253,116396,110252,110254,126640,130744,97981,97982,112331,118475,83658,85709,120524,120534,124634,120540,114399,114398,120550,114408,114411,114412,128753,116466,130807,120566,100089,130810,120577,112384,120576,120578,114436,124691,128799,108321,128800,108323,108322,108325,108324,124710,124716,116527,124719,130868,118587,128829,118591,128832,128835,106306,104262,100169,104265,112461,104270,124752,104272,104275,94035,124754,104274,94034,104277,116564,108374,104281,104280,104283,120666,130911,98143,110430,120672,116581,120687,120689,100209,120693,118645,120692,120695,126849,122754,112517,112516,112518,104331,87946,104330,98188,116625,116624,116629,130965,118676,116631,116630,122774,130966,104344,120734,104359,112550,98219,98218,120750,104366,108465,108469,108468,114616,131007,98238,100289,110535,112602,114650,118749,112621,112622,112625,112626,112629,124916,112633,112632,112634',
      'profile.mbopMoreFromMarriottOffers': 'OFF-66058',
      'profile.productTypeRecentlyViewed': 'hotels',
      'offer.id': '407957',
      'profile.IndirectTraffic': 'false',
      'experience.id': '477',
      'profile.MBOPPropertyIds': '',
      'profile.geolocationState': 'central',
      'geo.city': 'ashburn',
      'profile.MBOP_miRecentlyViewedProperties': 'true|true|cy|NYCES',
      'profile.rateTab': 'false',
      'profile.mbopGatedCodes': 'null',
      'profile.MBOPlastViewedMarsha': 'SATRC',
      'profile.bonvoyMember': 'MR:Basic',
      'crs.1107980.cluster_code': 'null',
      'profile.productRecentlyViewed': 'hotels',
      'profile.browsrLang': 'en-US,en;q=0.9',
      'profile.MBOPCountryCode': 'US',
      'profile.MBOPLastViewedOfferId': 'none',
      'profile.MBOPCountryCode_ACDL': 'US',
    },
    tertiaryImage: null,
  },
  //CoBrand | Banner slot
  'hpBanner-mbox': {
    adData: null,
    eVar48: 'CCOFFER-US-CH-hpBanner-0513-ACQ_FNA_5-6F7B-HYTL',
    impressionValue: 'CCOFFER-US-CH-hpBanner-0513-ACQ_FNA_5-6F7B-HYTL',
    analyticsName: null,
    metaTags: null,
    bullet1: null,
    bullet2: null,
    bullet3: null,
    callToActionText1: 'Learn More',
    callToActionText2: null,
    caption: null,
    captionUrl: null,
    descriptionLong: 'Free Night Awards valued up to 250,000 total points. Offer ends 3/11.',
    descriptionMedium: 'Free Nights valued up to 250,000 total points. Offer ends 3/11.',
    descriptionShort: 'Last chance: offer ends 3/11.',
    destinationUrl1:
      'https://creditcards.chase.com/a1/marriottbonvoyboundless/aep/LTO?CELL=6F7B&SPID=HYTL&returnURL=%2Fdefault%2Fpolaris.mi&alt_cust_id=8067CC9FF48178A0B0E373392E3F7F428.U1&cookie_id=51766619186210411282778984708483821798&mcd=CCOFFER-US-CH-hpBanner-0513-ACQ_FNA_5-6F7B-HYTL&rpcCode=0513',
    destinationUrl2: null,
    eyebrowText: null,
    headerLong: 'Last Chance: Earn ~~3~~ 5 Free Night Awards',
    headerMedium: 'Last Chance: Earn ~~3~~ 5 Free Night Awards',
    headerShort: 'Earn ~~3~~ 5 Free Nights',
    image: {
      roomTypeCodes: [],
      title: 'Yacht Experience 21936',
      caption: 'Sailing the Limassol coast',
      marketingCaption:
        'Couple enjoying a luxurious yacht experience along the stunning Limassol coastline with perfect weather and island vibes.',
      alternateDescription: 'Couple enjoying yacht cruise in Limassol sea',
      isPrimaryArchitectural: false,
      isSecondaryArchitectural: false,
      isPrimaryServices: false,
      isSecondaryServices: false,
      is360Photo: false,
      isPrimary: false,
      imageUrls: {
        panoramicHorizontal: '/is/image/marriotts7prod/lc-pfomd-yacht-experience-21936:Pano-Hor',
        panoramicVertical: '/is/image/marriotts7prod/lc-pfomd-yacht-experience-21936:Pano-Ver',
        wideHorizontal: '/is/image/marriotts7prod/lc-pfomd-yacht-experience-21936:Wide-Hor',
        wideVertical: '/is/image/marriotts7prod/lc-pfomd-yacht-experience-21936:Wide-Ver',
        featureHorizontal: '/is/image/marriotts7prod/lc-pfomd-yacht-experience-21936:Feature-Hor',
        featureVertical: '/is/image/marriotts7prod/lc-pfomd-yacht-experience-21936:Feature-Ver',
        classicHorizontal: '/is/image/marriotts7prod/lc-pfomd-yacht-experience-21936:Classic-Hor',
        classicVertical: '/is/image/marriotts7prod/lc-pfomd-yacht-experience-21936:Classic-Ver',
        standardVertical: '/is/image/marriotts7prod/lc-pfomd-yacht-experience-21936:Standard-Ver',
        standardHorizontal: '/is/image/marriotts7prod/lc-pfomd-yacht-experience-21936:Standard-Hor',
        square: '/is/image/marriotts7prod/lc-pfomd-yacht-experience-21936:Square',
        deviceSmall: null,
        flex: null,
        __typename: 'DCADacImageRendition',
      },
      imageSrc:
        '/content/dam/marriott-digital/lc/emea/hws/p/pfomd/en_us/photo/unlimited/assets/lc-pfomd-yacht-experience-21936.jpg',
      defaultImage: false,
      roomPoolCodes: [],
      __typename: 'DCADacImage',
    },
    imageAssetId:
      'L2NvbnRlbnQvZGFtL21hcnJpb3R0LWRpZ2l0YWwvbGMvZW1lYS9od3MvcC9wZm9tZC9lbl91cy9waG90by91bmxpbWl0ZWQvYXNzZXRzL2xjLXBmb21kLXlhY2h0LWV4cGVyaWVuY2UtMjE5MzYuanBn',
    legalLong: null,
    legalShort: null,
    localeOfContent: 'en_US',
    logo: {
      roomTypeCodes: [],
      title: '0513_OBO_Alarm_DCA',
      caption: '',
      marketingCaption: '',
      alternateDescription: 'Marriott Boundless Credit Card',
      isPrimaryArchitectural: false,
      isSecondaryArchitectural: false,
      isPrimaryServices: false,
      isSecondaryServices: false,
      is360Photo: false,
      isPrimary: false,
      imageUrls: {
        panoramicHorizontal: null,
        panoramicVertical: null,
        wideHorizontal: null,
        wideVertical: null,
        featureHorizontal: null,
        featureVertical: null,
        classicHorizontal: null,
        classicVertical: null,
        standardVertical: null,
        standardHorizontal: null,
        square: null,
        deviceSmall: null,
        flex: null,
        __typename: 'DCADacImageRendition',
      },
      imageSrc:
        '/content/dam/marriott-digital/digital-merchandising/us-canada/en_us/cobrand-cards/assets/pdt-0513-OBO-Alarm-DCA-833159038591492.png',
      defaultImage: false,
      roomPoolCodes: [],
      __typename: 'DCADacImage',
    },
    tertiaryImage: null,
    logoAssetId:
      'L2NvbnRlbnQvZGFtL21hcnJpb3R0LWRpZ2l0YWwvZGlnaXRhbC1tZXJjaGFuZGlzaW5nL3VzLWNhbmFkYS9lbl91cy9jb2JyYW5kLWNhcmRzL2Fzc2V0cy9wZHQtMDUxMy1PQk8tQWxhcm0tRENBLTgzMzE1OTAzODU5MTQ5Mi5wbmc=',
    mathLabel1: null,
    mathLabel2: null,
    mathLabel3: null,
    mathTitle: null,
    mathType: null,
    mathValue: null,
    mboxName: 'hpBanner-mbox',
    metadata: {
      campaignId: '6801',
      cell: '6F7B',
      countryCode: 'US',
      endDate: '2026-03-11',
      issuerCode: 'CH',
      loyaltyBar: false,
      mathOffer: false,
      merTag: '0513-ACQ_FNA_5',
      offerCode: 'ACQ_FNA_5',
      prequal: false,
      rpcCode: '0513',
      spid: 'HYTL',
      startDate: '2026-02-26',
      theme: 'Dark',
      title: '6801_FAID_ACQ_Q1_LTO_US_0513 Boundless_Chase_5FN_Strikethrough_Non-Res_HP Banner',
      type: 'CoBrand',
    },
    promotionalTag: 'Limited Time Offer',
    responseTokens: {
      'activity.name': 'homepage POlaris- hhpbanner mbox_test_data Copy',
      'geo.state': 'virginia',
      'activity.id': '132404',
      'experience.name': 'Experience B',
      'option.name': 'OFF-209275',
      'option.id': '3',
      'geo.ispName': 'netskope inc.',
      'geo.mobileCarrier': 'none',
      'geo.country': 'united states',
      'profile.activeActivities': '132402,132305,132343,132404,129675,129674,129677,129676,129679,129678,132237',
      'offer.id': '407240',
      'experience.id': '1',
      'geo.city': 'ashburn',
      'offer.name': 'OFF-209275',
    },
    __typename: 'DCADynamicContentMbox',
  },
  //CoBrand | variant: Non-Math
  'homeTallCardTopLeftTab1-mbox': {
    adData: null,
    eVar48: 'CCOFFER-US-CH-homeTallCardTopLeftTab1-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ',
    impressionValue: 'CCOFFER-US-CH-homeTallCardTopLeftTab1-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ',
    analyticsName: null,
    metaTags: null,
    bullet1: 'Free Night Award every year',
    bullet2: 'Automatic Silver Elite status',
    bullet3: 'Get 15 Elite Night Credits',
    callToActionText1: 'Learn More',
    callToActionText2: null,
    caption: null,
    captionUrl: null,
    descriptionLong: 'With the Marriott Bonvoy Boundless Card. Offer ends 8/10. Terms Apply. ',
    descriptionMedium: 'With the Marriott Bonvoy Boundless Card. Offer ends 8/10. Terms Apply. ',
    descriptionShort: 'With the Marriott Bonvoy Boundless Card. Offer ends 8/10. Terms Apply. ',
    destinationUrl1:
      'https://creditcards.chase.com/a1/marriottbonvoyboundless/FAIC/plus?CELL=6Q9X&SPID=J2SQ&returnURL=%2Fdefault%2Fpolaris.mi&alt_cust_id=8067CC9FF48178A0B0E373392E3F7F428.U1&cookie_id=51766619186210411282778984708483821798&mcd=CCOFFER-US-CH-homeTallCardTopLeftTab1-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ&rpcCode=0513',
    destinationUrl2: null,
    eyebrowText: null,
    headerLong: 'Lorem Ipsum Dolor Sit Ameti, Conseteture Adipiscing.',
    headerMedium: 'Lorem Ipsum Dolor Sit Ameti, Conseteture Adipiscing.',
    headerShort: 'Lorem Ipsum Dolor Sit Ameti, Conseteture Adipiscing.',
    image: null,
    imageAssetId: null,
    legalLong: null,
    legalShort: null,
    localeOfContent: 'en_US',
    logo: {
      roomTypeCodes: [],
      title: '0513_SPO_DCA_1174x885',
      caption: '',
      marketingCaption: '',
      alternateDescription: 'Chase Boundless card with "special offer" flag',
      isPrimaryArchitectural: false,
      isSecondaryArchitectural: false,
      isPrimaryServices: false,
      isSecondaryServices: false,
      is360Photo: false,
      isPrimary: false,
      imageUrls: {
        panoramicHorizontal: null,
        panoramicVertical: null,
        wideHorizontal: null,
        wideVertical: null,
        featureHorizontal: null,
        featureVertical: null,
        classicHorizontal: null,
        classicVertical: null,
        standardVertical: null,
        standardHorizontal: null,
        square: null,
        deviceSmall: null,
        flex: null,
        __typename: 'DCADacImageRendition',
      },
      imageSrc:
        'https://cache.marriott.com/content/dam/marriott-digital/digital-merchandising/us-canada/en_us/cobrand-cards/assets/pdt-0513-SPO-DCA-1174x885-470043103078058.png',
      defaultImage: false,
      roomPoolCodes: [],
      __typename: 'DCADacImage',
    },
    tertiaryImage: null,
    logoAssetId:
      'L2NvbnRlbnQvZGFtL21hcnJpb3R0LWRpZ2l0YWwvZGlnaXRhbC1tZXJjaGFuZGlzaW5nL3VzLWNhbmFkYS9lbl91cy9jb2JyYW5kLWNhcmRzL2Fzc2V0cy9wZHQtMDUxMy1TUE8tRENBLTExNzR4ODg1LTQ3MDA0MzEwMzA3ODA1OC5wbmc=',
    mathLabel1: null,
    mathLabel2: null,
    mathLabel3: null,
    mathTitle: null,
    mathType: null,
    mathValue: null,
    mboxName: 'homeTallCardTopLeftTab1-mbox',
    metadata: {
      campaignId: '7632',
      campaignType: 'appBenefitsBanner',
      cell: '6Q9X',
      countryCode: 'US',
      endDate: '2026-04-15',
      issuerCode: 'CH',
      loyaltyBar: true,
      mathOffer: false,
      merTag: '0513-ACQ_EG250_PT100k_TEST_NoAir',
      offerCode: 'ACQ_EG250_PT100k_TEST_NoAir',
      prequal: false,
      rpcCode: '0513',
      spid: 'J2SQ',
      startDate: '2026-03-19',
      theme: 'light',
      title: '7632_FAIC_ACQ_Q1_BAU+_US_0513 Boundless_Chase_4FN_2026_NonRes_TEST_NOAIR_AppWall',
      type: 'CoBrand',
    },
    promotionalTag: null,
    responseTokens: {
      'activity.name': 'Polaris|homeTallCardTopLeftTab1-mbox | Homepage | Testdata',
      'geo.state': 'virginia',
      'activity.id': '132237',
      'experience.name': 'Experience A',
      'option.name': 'polaris Test',
      'option.id': '2',
      'geo.ispName': 'netskope inc.',
      'geo.mobileCarrier': 'none',
      'geo.country': 'united states',
      'profile.activeActivities': '132402,132305,132343,132404,129675,129674,129677,129676,129679,129678,132237',
      'offer.id': '409570',
      'experience.id': '0',
      'geo.city': 'ashburn',
      'offer.name': 'polaris Test',
    },
    __typename: 'DCADynamicContentMbox',
  },
  //CoBrand | variant: Math-Points
  'homeTallCardTopLeftTab2-mbox': {
    adData: null,
    eVar48: 'CCOFFER-US-CH-homeTallCardTopLeftTab2-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ',
    impressionValue: 'CCOFFER-US-CH-homeTallCardTopLeftTab2-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ',
    analyticsName: null,
    metaTags: null,
    bullet1: 'Free Night Award every year',
    bullet2: 'Automatic Silver Elite status',
    bullet3: 'Get 15 Elite Night Credits',
    callToActionText1: 'Learn More',
    callToActionText2: null,
    caption: null,
    captionUrl: null,
    descriptionLong: 'Plus, earn up to 17X points at participating hotels.',
    descriptionMedium: 'Plus, earn up to 17X points at participating hotels.',
    descriptionShort: '+ up to 17X points at hotels.',
    destinationUrl1:
      'https://creditcards.chase.com/a1/marriottbonvoyboundless/FAIC/plus?CELL=6Q9X&SPID=J2SQ&returnURL=%2Fdefault%2Fpolaris.mi&alt_cust_id=8067CC9FF48178A0B0E373392E3F7F428.U1&cookie_id=51766619186210411282778984708483821798&mcd=CCOFFER-US-CH-homeTallCardTopLeftTab1-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ&rpcCode=0513',
    destinationUrl2: null,
    eyebrowText: null,
    headerLong: 'Earn 4 Free Nights Valued up to 200,000 Points Total',
    headerMedium: 'Earn 4 Free Nights Valued up to 200k Pts Total',
    headerShort: 'Earn 4 Free Nights',
    image: null,
    imageAssetId: null,
    legalLong: null,
    legalShort: null,
    localeOfContent: 'en_US',
    logo: {
      roomTypeCodes: [],
      title: '0513_SPO_DCA_1174x885',
      caption: '',
      marketingCaption: '',
      alternateDescription: 'Chase Boundless card with "special offer" flag',
      isPrimaryArchitectural: false,
      isSecondaryArchitectural: false,
      isPrimaryServices: false,
      isSecondaryServices: false,
      is360Photo: false,
      isPrimary: false,
      imageUrls: {
        panoramicHorizontal: null,
        panoramicVertical: null,
        wideHorizontal: null,
        wideVertical: null,
        featureHorizontal: null,
        featureVertical: null,
        classicHorizontal: null,
        classicVertical: null,
        standardVertical: null,
        standardHorizontal: null,
        square: null,
        deviceSmall: null,
        flex: null,
        __typename: 'DCADacImageRendition',
      },
      imageSrc:
        'https://cache.marriott.com/content/dam/marriott-digital/digital-merchandising/us-canada/en_us/cobrand-cards/assets/pdt-0513-SPO-DCA-1174x885-470043103078058.png',
      defaultImage: false,
      roomPoolCodes: [],
      __typename: 'DCADacImage',
    },
    tertiaryImage: null,
    logoAssetId:
      'L2NvbnRlbnQvZGFtL21hcnJpb3R0LWRpZ2l0YWwvZGlnaXRhbC1tZXJjaGFuZGlzaW5nL3VzLWNhbmFkYS9lbl91cy9jb2JyYW5kLWNhcmRzL2Fzc2V0cy9wZHQtMDUxMy1TUE8tRENBLTExNzR4ODg1LTQ3MDA0MzEwMzA3ODA1OC5wbmc=',
    mathLabel1: 'Your Point Balance',
    mathLabel2: 'Bonus Points',
    mathLabel3: 'New Points Total',
    mathTitle: 'POINTS',
    mathType: 'points',
    mathValue: '30,000',
    mboxName: 'homeTallCardTopLeftTab2-mbox',
    metadata: {
      campaignId: '7632',
      campaignType: 'appBenefitsBanner',
      cell: '6Q9X',
      countryCode: 'US',
      endDate: '2026-04-15',
      issuerCode: 'CH',
      loyaltyBar: true,
      mathOffer: false,
      merTag: '0513-ACQ_EG250_PT100k_TEST_NoAir',
      offerCode: 'ACQ_EG250_PT100k_TEST_NoAir',
      prequal: false,
      rpcCode: '0513',
      spid: 'J2SQ',
      startDate: '2026-03-19',
      theme: 'Dark',
      title: '7632_FAIC_ACQ_Q1_BAU+_US_0513 Boundless_Chase_4FN_2026_NonRes_TEST_NOAIR_AppWall',
      type: 'CoBrand',
    },
    promotionalTag: null,
    responseTokens: {
      'activity.name': 'Polaris|homeTallCardTopLeftTab2-mbox | Homepage | Testdata',
      'geo.state': 'virginia',
      'activity.id': '132237',
      'experience.name': 'Experience A',
      'option.name': 'polaris Test',
      'option.id': '2',
      'geo.ispName': 'netskope inc.',
      'geo.mobileCarrier': 'none',
      'geo.country': 'united states',
      'profile.activeActivities': '132402,132305,132343,132404,129675,129674,129677,129676,129679,129678,132237',
      'offer.id': '409570',
      'experience.id': '0',
      'geo.city': 'ashburn',
      'offer.name': 'polaris Test',
    },
    __typename: 'DCADynamicContentMbox',
  },
  //CoBrand | variant: Math-Nights
  'homeTallCardTopLeftTab3-mbox': {
    adData: null,
    eVar48: 'CCOFFER-US-CH-homeTallCardTopLeftTab3-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ',
    impressionValue: 'CCOFFER-US-CH-homeTallCardTopLeftTab3-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ',
    analyticsName: null,
    metaTags: null,
    bullet1: null,
    bullet2: null,
    bullet3: null,
    callToActionText1: 'Learn More',
    callToActionText2: null,
    caption: null,
    captionUrl: null,
    descriptionLong: 'Earn Up to $100 Daily Resort Credit',
    descriptionMedium: 'Earn Up to $100 Daily Resort Credit',
    descriptionShort: 'Earn 4 Free Nights',
    destinationUrl1:
      'https://creditcards.chase.com/a1/marriottbonvoyboundless/FAIC/plus?CELL=6Q9X&SPID=J2SQ&returnURL=%2Fdefault%2Fpolaris.mi&alt_cust_id=8067CC9FF48178A0B0E373392E3F7F428.U1&cookie_id=51766619186210411282778984708483821798&mcd=CCOFFER-US-CH-homeTallCardTopLeftTab1-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ&rpcCode=0513',
    destinationUrl2: null,
    eyebrowText: null,
    headerLong: 'Book 3+ nights and enjoy up to $100 credit per night at select resorts.',
    headerMedium: 'Book 3+ nights and enjoy up to $100 credit per night at select resorts.',
    headerShort: 'Earn 4 Free Nights',
    image: null,
    imageAssetId: null,
    legalLong: null,
    legalShort: null,
    localeOfContent: 'en_US',
    logo: {
      roomTypeCodes: [],
      title: '0513_SPO_DCA_1174x885',
      caption: '',
      marketingCaption: '',
      alternateDescription: 'Chase Boundless card with "special offer" flag',
      isPrimaryArchitectural: false,
      isSecondaryArchitectural: false,
      isPrimaryServices: false,
      isSecondaryServices: false,
      is360Photo: false,
      isPrimary: false,
      imageUrls: {
        panoramicHorizontal: null,
        panoramicVertical: null,
        wideHorizontal: null,
        wideVertical: null,
        featureHorizontal: null,
        featureVertical: null,
        classicHorizontal: null,
        classicVertical: null,
        standardVertical: null,
        standardHorizontal: null,
        square: null,
        deviceSmall: null,
        flex: null,
        __typename: 'DCADacImageRendition',
      },
      imageSrc:
        'https://cache.marriott.com/content/dam/marriott-digital/digital-merchandising/us-canada/en_us/cobrand-cards/assets/pdt-0513-SPO-DCA-1174x885-470043103078058.png',
      defaultImage: false,
      roomPoolCodes: [],
      __typename: 'DCADacImage',
    },
    tertiaryImage: null,
    logoAssetId:
      'L2NvbnRlbnQvZGFtL21hcnJpb3R0LWRpZ2l0YWwvZGlnaXRhbC1tZXJjaGFuZGlzaW5nL3VzLWNhbmFkYS9lbl91cy9jb2JyYW5kLWNhcmRzL2Fzc2V0cy9wZHQtMDUxMy1TUE8tRENBLTExNzR4ODg1LTQ3MDA0MzEwMzA3ODA1OC5wbmc=',
    mathLabel1: 'Your Nights',
    mathLabel2: 'Bonus Nights',
    mathLabel3: 'New Nights Total',
    mathTitle: '',
    mathType: 'nights',
    mathValue: '30',
    mboxName: 'homeTallCardTopLeftTab3-mbox',
    metadata: {
      campaignId: '7632',
      campaignType: 'appBenefitsBanner',
      cell: '6Q9X',
      countryCode: 'US',
      endDate: '2026-04-15',
      issuerCode: 'CH',
      loyaltyBar: true,
      mathOffer: false,
      merTag: '0513-ACQ_EG250_PT100k_TEST_NoAir',
      offerCode: 'ACQ_EG250_PT100k_TEST_NoAir',
      prequal: false,
      rpcCode: '0513',
      spid: 'J2SQ',
      startDate: '2026-03-19',
      theme: 'Dark',
      title: '7632_FAIC_ACQ_Q1_BAU+_US_0513 Boundless_Chase_4FN_2026_NonRes_TEST_NOAIR_AppWall',
      type: 'CoBrand',
    },
    promotionalTag: null,
    responseTokens: {
      'activity.name': 'Polaris|homeTallCardTopLeftTab3-mbox | Homepage | Testdata',
      'geo.state': 'virginia',
      'activity.id': '132237',
      'experience.name': 'Experience A',
      'option.name': 'polaris Test',
      'option.id': '2',
      'geo.ispName': 'netskope inc.',
      'geo.mobileCarrier': 'none',
      'geo.country': 'united states',
      'profile.activeActivities': '132402,132305,132343,132404,129675,129674,129677,129676,129679,129678,132237',
      'offer.id': '409570',
      'experience.id': '0',
      'geo.city': 'ashburn',
      'offer.name': 'polaris Test',
    },
    __typename: 'DCADynamicContentMbox',
  },
  //CoBrand | variant: Math-Currency
  'homeTallCardTopLeftTab4-mbox': {
    adData: null,
    eVar48: 'CCOFFER-US-CH-homeTallCardTopLeftTab4-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ',
    impressionValue: 'CCOFFER-US-CH-homeTallCardTopLeftTab4-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ',
    analyticsName: null,
    metaTags: null,
    bullet1: 'Free Night Award every year',
    bullet2: 'Automatic Silver Elite status',
    bullet3: 'Get 15 Elite Night Credits',
    callToActionText1: 'Learn More',
    callToActionText2: null,
    caption: null,
    captionUrl: null,
    descriptionLong: 'Plus, earn up to 17X points at participating hotels.',
    descriptionMedium: 'Plus, earn up to 17X points at participating hotels.',
    descriptionShort: '+ up to 17X points at hotels.',
    destinationUrl1:
      'https://creditcards.chase.com/a1/marriottbonvoyboundless/FAIC/plus?CELL=6Q9X&SPID=J2SQ&returnURL=%2Fdefault%2Fpolaris.mi&alt_cust_id=8067CC9FF48178A0B0E373392E3F7F428.U1&cookie_id=51766619186210411282778984708483821798&mcd=CCOFFER-US-CH-homeTallCardTopLeftTab4-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ&rpcCode=0513',
    destinationUrl2: null,
    eyebrowText: null,
    headerLong: 'Earn 4 Free Nights Valued up to 200,000 Points Total',
    headerMedium: 'Earn 4 Free Nights Valued up to 200k Pts Total',
    headerShort: 'Earn 4 Free Nights',
    image: null,
    imageAssetId: null,
    legalLong: null,
    legalShort: null,
    localeOfContent: 'en_US',
    logo: {
      roomTypeCodes: [],
      title: '0513_SPO_DCA_1174x885',
      caption: '',
      marketingCaption: '',
      alternateDescription: 'Chase Boundless card with "special offer" flag',
      isPrimaryArchitectural: false,
      isSecondaryArchitectural: false,
      isPrimaryServices: false,
      isSecondaryServices: false,
      is360Photo: false,
      isPrimary: false,
      imageUrls: {
        panoramicHorizontal: null,
        panoramicVertical: null,
        wideHorizontal: null,
        wideVertical: null,
        featureHorizontal: null,
        featureVertical: null,
        classicHorizontal: null,
        classicVertical: null,
        standardVertical: null,
        standardHorizontal: null,
        square: null,
        deviceSmall: null,
        flex: null,
        __typename: 'DCADacImageRendition',
      },
      imageSrc:
        'https://cache.marriott.com/content/dam/marriott-digital/digital-merchandising/us-canada/en_us/cobrand-cards/assets/pdt-0513-SPO-DCA-1174x885-470043103078058.png',
      defaultImage: false,
      roomPoolCodes: [],
      __typename: 'DCADacImage',
    },
    tertiaryImage: null,
    logoAssetId:
      'L2NvbnRlbnQvZGFtL21hcnJpb3R0LWRpZ2l0YWwvZGlnaXRhbC1tZXJjaGFuZGlzaW5nL3VzLWNhbmFkYS9lbl91cy9jb2JyYW5kLWNhcmRzL2Fzc2V0cy9wZHQtMDUxMy1TUE8tRENBLTExNzR4ODg1LTQ3MDA0MzEwMzA3ODA1OC5wbmc=',
    mathLabel1: 'Total Hotel Stay',
    mathLabel2: 'eGiftCard',
    mathLabel3: 'Total After eGiftCard',
    mathTitle: '',
    mathType: 'currency',
    mathValue: '-100',
    mboxName: 'homeTallCardTopLeftTab4-mbox',
    metadata: {
      campaignId: '7632',
      campaignType: 'appBenefitsBanner',
      cell: '6Q9X',
      countryCode: 'US',
      endDate: '2026-04-15',
      issuerCode: 'CH',
      loyaltyBar: true,
      mathOffer: false,
      merTag: '0513-ACQ_EG250_PT100k_TEST_NoAir',
      offerCode: 'ACQ_EG250_PT100k_TEST_NoAir',
      prequal: false,
      rpcCode: '0513',
      spid: 'J2SQ',
      startDate: '2026-03-19',
      theme: 'Dark',
      title: '7632_FAIC_ACQ_Q1_BAU+_US_0513 Boundless_Chase_4FN_2026_NonRes_TEST_NOAIR_AppWall',
      type: 'CoBrand',
    },
    promotionalTag: null,
    responseTokens: {
      'activity.name': 'Polaris|homeTallCardTopLeftTab4-mbox | Homepage | Testdata',
      'geo.state': 'virginia',
      'activity.id': '132237',
      'experience.name': 'Experience A',
      'option.name': 'polaris Test',
      'option.id': '2',
      'geo.ispName': 'netskope inc.',
      'geo.mobileCarrier': 'none',
      'geo.country': 'united states',
      'profile.activeActivities': '132402,132305,132343,132404,129675,129674,129677,129676,129679,129678,132237',
      'offer.id': '409570',
      'experience.id': '0',
      'geo.city': 'ashburn',
      'offer.name': 'polaris Test',
    },
    __typename: 'DCADynamicContentMbox',
  },
  //Non-CoBrand | Offers -> PDC
  'homeTallCardTopRightTab1-mbox': {
    adData: null,
    eVar48: 'CCOFFER-US-CH-homeTallCardTopRightTab1-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ',
    impressionValue: 'CCOFFER-US-CH-homeTallCardTopRightTab1-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ',
    analyticsName: null,
    metaTags: null,
    bullet1: 'Free Night Award every year',
    bullet2: 'Automatic Silver Elite status',
    bullet3: 'Get 15 Elite Night Credits',
    callToActionText1: 'Learn More',
    callToActionText2: null,
    caption: null,
    captionUrl: null,
    descriptionLong: 'Plus, earn up to 17X points at participating hotels.',
    descriptionMedium: 'Plus, earn up to 17X points at participating hotels.',
    descriptionShort: '+ up to 17X points at hotels.',
    destinationUrl1:
      'https://creditcards.chase.com/a1/marriottbonvoyboundless/FAIC/plus?CELL=6Q9X&SPID=J2SQ&returnURL=%2Fdefault%2Fpolaris.mi&alt_cust_id=8067CC9FF48178A0B0E373392E3F7F428.U1&cookie_id=51766619186210411282778984708483821798&mcd=CCOFFER-US-CH-homeTallCardTopRightTab1-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ&rpcCode=0513',
    destinationUrl2: null,
    eyebrowText: null,
    headerLong: 'Earn 4 Free Nights Valued up to 200,000 Points Total',
    headerMedium: 'Earn 4 Free Nights Valued up to 200k Pts Total',
    headerShort: 'Earn 4 Free Nights',
    image: null,
    imageAssetId: null,
    legalLong: null,
    legalShort: null,
    localeOfContent: 'en_US',
    logo: {
      roomTypeCodes: [],
      title: '0513_SPO_DCA_1174x885',
      caption: '',
      marketingCaption: '',
      alternateDescription: 'Chase Boundless card with "special offer" flag',
      isPrimaryArchitectural: false,
      isSecondaryArchitectural: false,
      isPrimaryServices: false,
      isSecondaryServices: false,
      is360Photo: false,
      isPrimary: false,
      imageUrls: {
        panoramicHorizontal: null,
        panoramicVertical: null,
        wideHorizontal: null,
        wideVertical: null,
        featureHorizontal: null,
        featureVertical: null,
        classicHorizontal: null,
        classicVertical: null,
        standardVertical: null,
        standardHorizontal: null,
        square: null,
        deviceSmall: null,
        flex: null,
        __typename: 'DCADacImageRendition',
      },
      imageSrc:
        'https://cache.marriott.com/content/dam/marriott-digital/digital-merchandising/us-canada/en_us/cobrand-cards/assets/pdt-0513-SPO-DCA-1174x885-470043103078058.png',
      defaultImage: false,
      roomPoolCodes: [],
      __typename: 'DCADacImage',
    },
    tertiaryImage: null,
    logoAssetId:
      'L2NvbnRlbnQvZGFtL21hcnJpb3R0LWRpZ2l0YWwvZGlnaXRhbC1tZXJjaGFuZGlzaW5nL3VzLWNhbmFkYS9lbl91cy9jb2JyYW5kLWNhcmRzL2Fzc2V0cy9wZHQtMDUxMy1TUE8tRENBLTExNzR4ODg1LTQ3MDA0MzEwMzA3ODA1OC5wbmc=',
    mathLabel1: null,
    mathLabel2: null,
    mathLabel3: null,
    mathTitle: null,
    mathType: null,
    mathValue: null,
    mboxName: 'homeTallCardTopRightTab1-mbox',
    metadata: {
      campaignId: '7632',
      campaignType: 'appBenefitsBanner',
      cell: '6Q9X',
      countryCode: 'US',
      endDate: '2026-04-15',
      issuerCode: 'CH',
      loyaltyBar: true,
      mathOffer: false,
      merTag: '0513-ACQ_EG250_PT100k_TEST_NoAir',
      offerCode: 'ACQ_EG250_PT100k_TEST_NoAir',
      prequal: false,
      rpcCode: '0513',
      spid: 'J2SQ',
      startDate: '2026-03-19',
      theme: 'Dark',
      title: '7632_FAIC_ACQ_Q1_BAU+_US_0513 Boundless_Chase_4FN_2026_NonRes_TEST_NOAIR_AppWall',
      type: 'Non-CoBrand',
    },
    promotionalTag: null,
    responseTokens: {
      'activity.name': 'Polaris|homeTallCardTopRightTab1-mbox | Homepage | Testdata Copy Copy',
      'geo.state': 'virginia',
      'activity.id': '132342',
      'experience.name': 'Experience A',
      'option.name': 'polaris Test',
      'option.id': '2',
      'geo.ispName': 'netskope inc.',
      'geo.mobileCarrier': 'none',
      'geo.country': 'united states',
      'profile.activeActivities': '132402,132305,132342,132343,132404,129675,129674,129677,129676,129679,129678,132237',
      'offer.id': '409864',
      'experience.id': '0',
      'geo.city': 'ashburn',
      'offer.name': 'polaris Test',
    },
    __typename: 'DCADynamicContentMbox',
  },
  //Non-CoBrand | Offers -> square PDC
  'homeSqCardBannerMiddleTab1-mbox': {
    adData: null,
    eVar48: 'CCOFFER-US-CH-homeSqCardBannerMiddleTab1-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ',
    impressionValue: 'CCOFFER-US-CH-homeSqCardBannerMiddleTab1-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ',
    analyticsName: null,
    metaTags: null,
    bullet1: 'Free Night Award every year',
    bullet2: 'Automatic Silver Elite status',
    bullet3: 'Get 15 Elite Night Credits',
    callToActionText1: 'Learn More',
    callToActionText2: null,
    caption: null,
    captionUrl: null,
    descriptionLong: 'Plus, earn up to 17X points at participating hotels.',
    descriptionMedium: 'Plus, earn up to 17X points at participating hotels.',
    descriptionShort: '+ up to 17X points at hotels.',
    destinationUrl1:
      'https://creditcards.chase.com/a1/marriottbonvoyboundless/FAIC/plus?CELL=6Q9X&SPID=J2SQ&returnURL=%2Fdefault%2Fpolaris.mi&alt_cust_id=8067CC9FF48178A0B0E373392E3F7F428.U1&cookie_id=51766619186210411282778984708483821798&mcd=CCOFFER-US-CH-homeSqCardBannerMiddleTab1-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ&rpcCode=0513',
    destinationUrl2: null,
    eyebrowText: null,
    headerLong: 'Earn 4 Free Nights Valued up to 200,000 Points Total',
    headerMedium: 'Earn 4 Free Nights Valued up to 200k Pts Total',
    headerShort: 'Earn 4 Free Nights',
    image: null,
    imageAssetId: null,
    legalLong: null,
    legalShort: null,
    localeOfContent: 'en_US',
    logo: {
      roomTypeCodes: [],
      title: '0513_SPO_DCA_1174x885',
      caption: '',
      marketingCaption: '',
      alternateDescription: 'Chase Boundless card with "special offer" flag',
      isPrimaryArchitectural: false,
      isSecondaryArchitectural: false,
      isPrimaryServices: false,
      isSecondaryServices: false,
      is360Photo: false,
      isPrimary: false,
      imageUrls: {
        panoramicHorizontal: null,
        panoramicVertical: null,
        wideHorizontal: null,
        wideVertical: null,
        featureHorizontal: null,
        featureVertical: null,
        classicHorizontal: null,
        classicVertical: null,
        standardVertical: null,
        standardHorizontal: null,
        square: null,
        deviceSmall: null,
        flex: null,
        __typename: 'DCADacImageRendition',
      },
      imageSrc:
        'https://cache.marriott.com/content/dam/marriott-digital/digital-merchandising/us-canada/en_us/cobrand-cards/assets/pdt-0513-SPO-DCA-1174x885-470043103078058.png',
      defaultImage: false,
      roomPoolCodes: [],
      __typename: 'DCADacImage',
    },
    tertiaryImage: null,
    logoAssetId:
      'L2NvbnRlbnQvZGFtL21hcnJpb3R0LWRpZ2l0YWwvZGlnaXRhbC1tZXJjaGFuZGlzaW5nL3VzLWNhbmFkYS9lbl91cy9jb2JyYW5kLWNhcmRzL2Fzc2V0cy9wZHQtMDUxMy1TUE8tRENBLTExNzR4ODg1LTQ3MDA0MzEwMzA3ODA1OC5wbmc=',
    mathLabel1: null,
    mathLabel2: null,
    mathLabel3: null,
    mathTitle: null,
    mathType: null,
    mathValue: null,
    mboxName: 'homeSqCardBannerMiddleTab1-mbox',
    metadata: {
      campaignId: '7632',
      campaignType: 'appBenefitsBanner',
      cell: '6Q9X',
      countryCode: 'US',
      endDate: '2026-04-15',
      issuerCode: 'CH',
      loyaltyBar: true,
      mathOffer: false,
      merTag: '0513-ACQ_EG250_PT100k_TEST_NoAir',
      offerCode: 'ACQ_EG250_PT100k_TEST_NoAir',
      prequal: false,
      rpcCode: '0513',
      spid: 'J2SQ',
      startDate: '2026-03-19',
      theme: 'Dark',
      title: '7632_FAIC_ACQ_Q1_BAU+_US_0513 Boundless_Chase_4FN_2026_NonRes_TEST_NOAIR_AppWall',
      type: 'Non-CoBrand',
    },
    promotionalTag: null,
    responseTokens: {
      'activity.name': 'Polaris|homeSqCardBannerMiddleTab1-mbox| Homepage | Testdata Copy Copy Copy',
      'geo.state': 'virginia',
      'activity.id': '132343',
      'experience.name': 'Experience A',
      'option.name': 'polaris Test',
      'option.id': '2',
      'geo.ispName': 'netskope inc.',
      'geo.mobileCarrier': 'none',
      'geo.country': 'united states',
      'profile.activeActivities': '132402,132305,132343,132404,129675,129674,129677,129676,129679,129678,132237',
      'offer.id': '409865',
      'experience.id': '0',
      'geo.city': 'ashburn',
      'offer.name': 'polaris Test',
    },
    __typename: 'DCADynamicContentMbox',
  },
  //Non-CoBrand | Offers -> PDC
  'popularOffersHomepage2-mbox': {
    adData: null,
    eVar48: 'CCOFFER-US-CH-popularOffersHomepage2-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ',
    impressionValue: 'CCOFFER-US-CH-popularOffersHomepage2-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ',
    analyticsName: null,
    metaTags: null,
    bullet1: 'Free Night Award every year',
    bullet2: 'Automatic Silver Elite status',
    bullet3: 'Get 15 Elite Night Credits',
    callToActionText1: 'Learn More',
    callToActionText2: null,
    caption: null,
    captionUrl: null,
    descriptionLong: 'Plus, earn up to 17X points at participating hotels.',
    descriptionMedium: 'Plus, earn up to 17X points at participating hotels.',
    descriptionShort: '+ up to 17X points at hotels.',
    destinationUrl1:
      'https://creditcards.chase.com/a1/marriottbonvoyboundless/FAIC/plus?CELL=6Q9X&SPID=J2SQ&returnURL=%2Fdefault%2Fpolaris.mi&alt_cust_id=8067CC9FF48178A0B0E373392E3F7F428.U1&cookie_id=51766619186210411282778984708483821798&mcd=CCOFFER-US-CH-homeSqCardBannerMiddleTab1-0513-ACQ_EG250_PT100k_TEST_NoAir-6Q9X-J2SQ&rpcCode=0513',
    destinationUrl2: null,
    eyebrowText: null,
    headerLong: 'Earn 4 Free Nights Valued up to 200,000 Points Total',
    headerMedium: 'Earn 4 Free Nights Valued up to 200k Pts Total',
    headerShort: 'Earn 4 Free Nights',
    image: null,
    imageAssetId: null,
    legalLong: null,
    legalShort: null,
    localeOfContent: 'en_US',
    logo: {
      roomTypeCodes: [],
      title: '0513_SPO_DCA_1174x885',
      caption: '',
      marketingCaption: '',
      alternateDescription: 'Chase Boundless card with "special offer" flag',
      isPrimaryArchitectural: false,
      isSecondaryArchitectural: false,
      isPrimaryServices: false,
      isSecondaryServices: false,
      is360Photo: false,
      isPrimary: false,
      imageUrls: {
        panoramicHorizontal: null,
        panoramicVertical: null,
        wideHorizontal: null,
        wideVertical: null,
        featureHorizontal: null,
        featureVertical: null,
        classicHorizontal: null,
        classicVertical: null,
        standardVertical: null,
        standardHorizontal: null,
        square: null,
        deviceSmall: null,
        flex: null,
        __typename: 'DCADacImageRendition',
      },
      imageSrc:
        'https://cache.marriott.com/content/dam/marriott-digital/digital-merchandising/us-canada/en_us/cobrand-cards/assets/pdt-0513-SPO-DCA-1174x885-470043103078058.png',
      defaultImage: false,
      roomPoolCodes: [],
      __typename: 'DCADacImage',
    },
    tertiaryImage: null,
    logoAssetId:
      'L2NvbnRlbnQvZGFtL21hcnJpb3R0LWRpZ2l0YWwvZGlnaXRhbC1tZXJjaGFuZGlzaW5nL3VzLWNhbmFkYS9lbl91cy9jb2JyYW5kLWNhcmRzL2Fzc2V0cy9wZHQtMDUxMy1TUE8tRENBLTExNzR4ODg1LTQ3MDA0MzEwMzA3ODA1OC5wbmc=',
    mathLabel1: null,
    mathLabel2: null,
    mathLabel3: null,
    mathTitle: null,
    mathType: null,
    mathValue: null,
    mboxName: 'popularOffersHomepage2-mbox',
    metadata: {
      campaignId: '7632',
      campaignType: 'appBenefitsBanner',
      cell: '6Q9X',
      countryCode: 'US',
      endDate: '2026-04-15',
      issuerCode: 'CH',
      loyaltyBar: true,
      mathOffer: false,
      merTag: '0513-ACQ_EG250_PT100k_TEST_NoAir',
      offerCode: 'ACQ_EG250_PT100k_TEST_NoAir',
      prequal: false,
      rpcCode: '0513',
      spid: 'J2SQ',
      startDate: '2026-03-19',
      theme: 'Dark',
      title: '7632_FAIC_ACQ_Q1_BAU+_US_0513 Boundless_Chase_4FN_2026_NonRes_TEST_NOAIR_AppWall',
      type: 'Non-CoBrand',
    },
    promotionalTag: null,
    responseTokens: {
      'activity.name': 'Polaris|popularOffersHomepage2-mbox| Homepage | Testdata Copy Copy Copy',
      'geo.state': 'virginia',
      'activity.id': '132343',
      'experience.name': 'Experience A',
      'option.name': 'polaris Test',
      'option.id': '2',
      'geo.ispName': 'netskope inc.',
      'geo.mobileCarrier': 'none',
      'geo.country': 'united states',
      'profile.activeActivities': '132402,132305,132343,132404,129675,129674,129677,129676,129679,129678,132237',
      'offer.id': '409865',
      'experience.id': '0',
      'geo.city': 'ashburn',
      'offer.name': 'polaris Test',
    },
    __typename: 'DCADynamicContentMbox',
  },
  //Mango true | Riott media card
  'popularOffersHomepage1-mbox': {
    adData: [
      {
        click_tracking_url:
          'https://marriottmedianetwork.uat.koddi.io/event-collection/beacon?action=click&trackingData=9ElqoFRnH1ighEEymI%2B0tdI2nqYkTjDx0oozYDiz66b4KHk0IFw4zorOlxDq6wIwxmWH7rayxYqZYrR0GBlnQKtgOIkUM1YMxf4FRaXIbV390tGShUafj8BTrSLuXQjcfY8a7UixxekEe9OAr3CMkpgL5D82kJTwcw%2Bbozxp4WG2gpz8WGm19Esr6KpTY0uQRFsNK%2FwEvLZQrPoLBRpAVTzxh9cmk3YOG8L7ltCcrSSSUuq1dkdyKcMfysFHmc9fw5dk9hhLQb59bhXcA4QcwwoV7rlQo5bjV6HRC3JmOZYzOouPvY6UkiN1%2BD004dWvNC9DjSHtzz833CFCnYMFnVsxsU6P1W5U%2BslGOj9az%2BqGFMC4IDr8n%2F3JppAuBL1xjXxiEfQP3z3%2F8jpGSrQZWqZAAgDljFTzvyY0J0UVdoxWYrz2RyOYWDySTjb3nt1UB1kJLaTvQjdJPGQRmtEssjIakShdloY5zB8WqKCSMjlABYeyXNsGQAA7VDt3Ew%2ByoMOE8iPyCcsORlAAcn615WuqVHL3kkREkUqzcfH8sTZOICC7IY3XI3bvH1prEbS0laJdWZcuHRCSaVdvEwHPz3DLVovcXo0olY17T4WS8slGbU7JuTOa6Ju43uO%2BUEATJ3cHwJ%2BhEKbZdH%2FaYyYf%2BHZbd8RtNyIM8I%2B80adnRlsp3mAIDUHhwjvnI9SdhRDREmTxjH%2BLJ4HD0dNeO2XcjopPWEKQp%2FpQlQZavGbLlkjTbRaePagr16F36ec5R4tjmWYwl6Cw8MpguLVW%2F7qNoAW%2FNJsCaMvKQAKqbTYSpSsV6YuBathQHW6%2FJYvHQ%2BiYe2broKFFejJO%2BfhavcVedi%2BODLOit1ho1cIABw4heiVGIGK9iUF%2BmLp8NDcPXtB9K9Ss8jn85e4hQyBKIZh0NNPbj%2BvNHqEnmrmA8Pgh32lDoOMwvmyTnDkn4VOPf0lnqUtQ202tc3Wl4KH8nlQw5dVoyMoO60EMPfIHwc2WlYBKlvAmNeREt%2FKLBBXTViNHcW5UDEEGS4%2FJa8n2WJxsADEX5uHmN6MQH00pP6xGvOFavhXxpbZwHZvwNPOeUBzjnl0YqB0erLUNEpmY75FVOawsFsCo7gRHeUWiIVJQlm0lRW%2BreNSTc%2FWhg5ZVdn4lGIxOU5Dc0niYwZ1Z9jvdeL1vunZH0qJH2y21oBQxHPg2EkIIJhKIjeHKRw9f84NQ9mNMqaSSAzcViOpeUh2qg08DLAuZnnBx3LJOh8H%2B6ddWFdoHndb%2BVW3YvTUCAVB6JU%2BVmMGGvTXXr2VGIEWUIedo3pEd%2FD%2FKxZcEGs9ZaGfPJ%2BCzokwTnW630pPKg6gv%2Fa%2F3riF3RAdntQH78qHQTsKEfWbCgPUb0jo%2BxTiapxBlMIeDh6svf90ZPt7XDtvLd1jvilh4g2qULYYep8IAOV2%2BkAale%2BkuYa1YqW7wgqMloS53ogMiW%2BFEPacBtiXDSSUcPpza452VrVi5SLuXACf0722V%2BMfQxKIbRUH5mGkbOAfQBail9dqvy1YqQ7A2kAOka5n%2FabeBtnZKxIsd5Ohh5O0goX8VbMdG3gdXpdky34sEyPvZvZXGwFacmlALHvDAl102Hb9R2gqBplop12HwuEzIdyPZ%2BPBzX0RXpIgFVIl%2FzvZv5grNLKyB2VWsu2TKVFnCvabkBMqZLXLWEBKJLJJRs0VUYl2oLY%2BrwM5sUQRuaBVgJVQsFhbNEmhKYP%2FKLZ6Pb522Zv2iBL9O2DUB7Pg7SBGtgc1YLbcqG2cGPpFGQX6Wyy9XiOlud2WM%2BS5GfAyI9g42Z98K107CFrrJo3Qs5XW9MS5Yb6MYFt5ezrWe63pdLfjiXdVbOo5gZ1ssPli82gsn7h2MZBqwIxSwdCb88ssfMLgDyGLQ6Q2y2IkniHOyJlwnam6OpV07Sxgohtr7sYzhJrdsPIwuoAtbpQGteaBirkQqZ17n730mHUS72PPDs4aQABvYxHDZYel3wnYABPNnx79CrewF09R5OAhNZstI1fME6HN2xYfUekMGP%2B7T6GtUGPr2iBGQJ8Tv8fwXH5O37BuGRqLPxkiS0AW8W9o47of1arI038ntBeTNtqLiRSMBrtgLyQToW7TXZmKqXnftGnzd2xqLKVJno4rFOQ9YDMI90n1wL256cdNS4bPRSqcux856lPyOiJymKkT6qEaHXYR6Ub6E%2Fv9hbbbkPTfbhUMls%2BJ9UkfZwpFqXkvZN8D6X8ElyfangS5PeFarCpTzhuYAlPVScWB%2Ft%2BYY126KaReN7Hvgwb580WHseTmD2hkkEaHuZceqyHmxGlhyBRFq0piX07cSj5LiqCmsKoZHACtXR28H3BjP0XIZ549C8z%2FCF7B%2FwMMoO1dA1XGSGtU7m0n4NNBho%2BfPWqKAQA9YLDqDB7P4%2BREBe75iwOcNb%2FV8o1l8JLBh4Rel8EPC0rCM4Y8BqKa7Fp%2ByVIZmDsMc0ydU8Eqj008O%2FD%2B6G9xNWOmGcNJDNCBbMEWLvv4yde7XLALXp2TT%2FdT9FOtzs14pzMswMw%3D%3D&rank={rank}&clientName=Marriott Media Network&beaconIssued=2026-03-11T22:10:34Z',
        bidder: '24722479',
        advertiser_name: 'Test Advertiser',
        impression_tracking_url:
          'https://marriottmedianetwork.uat.koddi.io/event-collection/beacon?action=impression&trackingData=9ElqoFRnH1ighEEymI%2B0tdI2nqYkTjDx0oozYDiz66b4KHk0IFw4zorOlxDq6wIwxmWH7rayxYqZYrR0GBlnQKtgOIkUM1YMxf4FRaXIbV390tGShUafj8BTrSLuXQjcfY8a7UixxekEe9OAr3CMkpgL5D82kJTwcw%2Bbozxp4WG2gpz8WGm19Esr6KpTY0uQRFsNK%2FwEvLZQrPoLBRpAVTzxh9cmk3YOG8L7ltCcrSSSUuq1dkdyKcMfysFHmc9fw5dk9hhLQb59bhXcA4QcwwoV7rlQo5bjV6HRC3JmOZYzOouPvY6UkiN1%2BD004dWvNC9DjSHtzz833CFCnYMFnVsxsU6P1W5U%2BslGOj9az%2BqGFMC4IDr8n%2F3JppAuBL1xjXxiEfQP3z3%2F8jpGSrQZWqZAAgDljFTzvyY0J0UVdoxWYrz2RyOYWDySTjb3nt1UB1kJLaTvQjdJPGQRmtEssjIakShdloY5zB8WqKCSMjlABYeyXNsGQAA7VDt3Ew%2ByoMOE8iPyCcsORlAAcn615WuqVHL3kkREkUqzcfH8sTZOICC7IY3XI3bvH1prEbS0laJdWZcuHRCSaVdvEwHPz3DLVovcXo0olY17T4WS8slGbU7JuTOa6Ju43uO%2BUEATJ3cHwJ%2BhEKbZdH%2FaYyYf%2BHZbd8RtNyIM8I%2B80adnRlsp3mAIDUHhwjvnI9SdhRDREmTxjH%2BLJ4HD0dNeO2XcjopPWEKQp%2FpQlQZavGbLlkjTbRaePagr16F36ec5R4tjmWYwl6Cw8MpguLVW%2F7qNoAW%2FNJsCaMvKQAKqbTYSpSsV6YuBathQHW6%2FJYvHQ%2BiYe2broKFFejJO%2BfhavcVedi%2BODLOit1ho1cIABw4heiVGIGK9iUF%2BmLp8NDcPXtB9K9Ss8jn85e4hQyBKIZh0NNPbj%2BvNHqEnmrmA8Pgh32lDoOMwvmyTnDkn4VOPf0lnqUtQ202tc3Wl4KH8nlQw5dVoyMoO60EMPfIHwc2WlYBKlvAmNeREt%2FKLBBXTViNHcW5UDEEGS4%2FJa8n2WJxsADEX5uHmN6MQH00pP6xGvOFavhXxpbZwHZvwNPOeUBzjnl0YqB0erLUNEpmY75FVOawsFsCo7gRHeUWiIVJQlm0lRW%2BreNSTc%2FWhg5ZVdn4lGIxOU5Dc0niYwZ1Z9jvdeL1vunZH0qJH2y21oBQxHPg2EkIIJhKIjeHKRw9f84NQ9mNMqaSSAzcViOpeUh2qg08DLAuZnnBx3LJOh8H%2B6ddWFdoHndb%2BVW3YvTUCAVB6JU%2BVmMGGvTXXr2VGIEWUIedo3pEd%2FD%2FKxZcEGs9ZaGfPJ%2BCzokwTnW630pPKg6gv%2Fa%2F3riF3RAdntQH78qHQTsKEfWbCgPUb0jo%2BxTiapxBlMIeDh6svf90ZPt7XDtvLd1jvilh4g2qULYYep8IAOV2%2BkAale%2BkuYa1YqW7wgqMloS53ogMiW%2BFEPacBtiXDSSUcPpza452VrVi5SLuXACf0722V%2BMfQxKIbRUH5mGkbOAfQBail9dqvy1YqQ7A2kAOka5n%2FabeBtnZKxIsd5Ohh5O0goX8VbMdG3gdXpdky34sEyPvZvZXGwFacmlALHvDAl102Hb9R2gqBplop12HwuEzIdyPZ%2BPBzX0RXpIgFVIl%2FzvZv5grNLKyB2VWsu2TKVFnCvabkBMqZLXLWEBKJLJJRs0VUYl2oLY%2BrwM5sUQRuaBVgJVQsFhbNEmhKYP%2FKLZ6Pb522Zv2iBL9O2DUB7Pg7SBGtgc1YLbcqG2cGPpFGQX6Wyy9XiOlud2WM%2BS5GfAyI9g42Z98K107CFrrJo3Qs5XW9MS5Yb6MYFt5ezrWe63pdLfjiXdVbOo5gZ1ssPli82gsn7h2MZBqwIxSwdCb88ssfMLgDyGLQ6Q2y2IkniHOyJlwnam6OpV07Sxgohtr7sYzhJrdsPIwuoAtbpQGteaBirkQqZ17n730mHUS72PPDs4aQABvYxHDZYel3wnYABPNnx79CrewF09R5OAhNZstI1fME6HN2xYfUekMGP%2B7T6GtUGPr2iBGQJ8Tv8fwXH5O37BuGRqLPxkiS0AW8W9o47of1arI038ntBeTNtqLiRSMBrtgLyQToW7TXZmKqXnftGnzd2xqLKVJno4rFOQ9YDMI90n1wL256cdNS4bPRSqcux856lPyOiJymKkT6qEaHXYR6Ub6E%2Fv9hbbbkPTfbhUMls%2BJ9UkfZwpFqXkvZN8D6X8ElyfangS5PeFarCpTzhuYAlPVScWB%2Ft%2BYY126KaReN7Hvgwb580WHseTmD2hkkEaHuZceqyHmxGlhyBRFq0piX07cSj5LiqCmsKoZHACtXR28H3BjP0XIZ549C8z%2FCF7B%2FwMMoO1dA1XGSGtU7m0n4NNBho%2BfPWqKAQA9YLDqDB7P4%2BREBe75iwOcNb%2FV8o1l8JLBh4Rel8EPC0rCM4Y8BqKa7Fp%2ByVIZmDsMc0ydU8Eqj008O%2FD%2B6G9xNWOmGcNJDNCBbMEWLvv4yde7XLALXp2TT%2FdT9FOtzs14pzMswMw%3D%3D&rank={rank}&ts={ts}&clientName=Marriott Media Network&beaconIssued=2026-03-11T22:10:34Z',
        custom_tracking_url:
          'https://marriottmedianetwork.uat.koddi.io/event-collection/beacon?action=tracking&trackingData=9ElqoFRnH1ighEEymI%2B0tdI2nqYkTjDx0oozYDiz66b4KHk0IFw4zorOlxDq6wIwxmWH7rayxYqZYrR0GBlnQKtgOIkUM1YMxf4FRaXIbV390tGShUafj8BTrSLuXQjcfY8a7UixxekEe9OAr3CMkpgL5D82kJTwcw%2Bbozxp4WG2gpz8WGm19Esr6KpTY0uQRFsNK%2FwEvLZQrPoLBRpAVTzxh9cmk3YOG8L7ltCcrSSSUuq1dkdyKcMfysFHmc9fw5dk9hhLQb59bhXcA4QcwwoV7rlQo5bjV6HRC3JmOZYzOouPvY6UkiN1%2BD004dWvNC9DjSHtzz833CFCnYMFnVsxsU6P1W5U%2BslGOj9az%2BqGFMC4IDr8n%2F3JppAuBL1xjXxiEfQP3z3%2F8jpGSrQZWqZAAgDljFTzvyY0J0UVdoxWYrz2RyOYWDySTjb3nt1UB1kJLaTvQjdJPGQRmtEssjIakShdloY5zB8WqKCSMjlABYeyXNsGQAA7VDt3Ew%2ByoMOE8iPyCcsORlAAcn615WuqVHL3kkREkUqzcfH8sTZOICC7IY3XI3bvH1prEbS0laJdWZcuHRCSaVdvEwHPz3DLVovcXo0olY17T4WS8slGbU7JuTOa6Ju43uO%2BUEATJ3cHwJ%2BhEKbZdH%2FaYyYf%2BHZbd8RtNyIM8I%2B80adnRlsp3mAIDUHhwjvnI9SdhRDREmTxjH%2BLJ4HD0dNeO2XcjopPWEKQp%2FpQlQZavGbLlkjTbRaePagr16F36ec5R4tjmWYwl6Cw8MpguLVW%2F7qNoAW%2FNJsCaMvKQAKqbTYSpSsV6YuBathQHW6%2FJYvHQ%2BiYe2broKFFejJO%2BfhavcVedi%2BODLOit1ho1cIABw4heiVGIGK9iUF%2BmLp8NDcPXtB9K9Ss8jn85e4hQyBKIZh0NNPbj%2BvNHqEnmrmA8Pgh32lDoOMwvmyTnDkn4VOPf0lnqUtQ202tc3Wl4KH8nlQw5dVoyMoO60EMPfIHwc2WlYBKlvAmNeREt%2FKLBBXTViNHcW5UDEEGS4%2FJa8n2WJxsADEX5uHmN6MQH00pP6xGvOFavhXxpbZwHZvwNPOeUBzjnl0YqB0erLUNEpmY75FVOawsFsCo7gRHeUWiIVJQlm0lRW%2BreNSTc%2FWhg5ZVdn4lGIxOU5Dc0niYwZ1Z9jvdeL1vunZH0qJH2y21oBQxHPg2EkIIJhKIjeHKRw9f84NQ9mNMqaSSAzcViOpeUh2qg08DLAuZnnBx3LJOh8H%2B6ddWFdoHndb%2BVW3YvTUCAVB6JU%2BVmMGGvTXXr2VGIEWUIedo3pEd%2FD%2FKxZcEGs9ZaGfPJ%2BCzokwTnW630pPKg6gv%2Fa%2F3riF3RAdntQH78qHQTsKEfWbCgPUb0jo%2BxTiapxBlMIeDh6svf90ZPt7XDtvLd1jvilh4g2qULYYep8IAOV2%2BkAale%2BkuYa1YqW7wgqMloS53ogMiW%2BFEPacBtiXDSSUcPpza452VrVi5SLuXACf0722V%2BMfQxKIbRUH5mGkbOAfQBail9dqvy1YqQ7A2kAOka5n%2FabeBtnZKxIsd5Ohh5O0goX8VbMdG3gdXpdky34sEyPvZvZXGwFacmlALHvDAl102Hb9R2gqBplop12HwuEzIdyPZ%2BPBzX0RXpIgFVIl%2FzvZv5grNLKyB2VWsu2TKVFnCvabkBMqZLXLWEBKJLJJRs0VUYl2oLY%2BrwM5sUQRuaBVgJVQsFhbNEmhKYP%2FKLZ6Pb522Zv2iBL9O2DUB7Pg7SBGtgc1YLbcqG2cGPpFGQX6Wyy9XiOlud2WM%2BS5GfAyI9g42Z98K107CFrrJo3Qs5XW9MS5Yb6MYFt5ezrWe63pdLfjiXdVbOo5gZ1ssPli82gsn7h2MZBqwIxSwdCb88ssfMLgDyGLQ6Q2y2IkniHOyJlwnam6OpV07Sxgohtr7sYzhJrdsPIwuoAtbpQGteaBirkQqZ17n730mHUS72PPDs4aQABvYxHDZYel3wnYABPNnx79CrewF09R5OAhNZstI1fME6HN2xYfUekMGP%2B7T6GtUGPr2iBGQJ8Tv8fwXH5O37BuGRqLPxkiS0AW8W9o47of1arI038ntBeTNtqLiRSMBrtgLyQToW7TXZmKqXnftGnzd2xqLKVJno4rFOQ9YDMI90n1wL256cdNS4bPRSqcux856lPyOiJymKkT6qEaHXYR6Ub6E%2Fv9hbbbkPTfbhUMls%2BJ9UkfZwpFqXkvZN8D6X8ElyfangS5PeFarCpTzhuYAlPVScWB%2Ft%2BYY126KaReN7Hvgwb580WHseTmD2hkkEaHuZceqyHmxGlhyBRFq0piX07cSj5LiqCmsKoZHACtXR28H3BjP0XIZ549C8z%2FCF7B%2FwMMoO1dA1XGSGtU7m0n4NNBho%2BfPWqKAQA9YLDqDB7P4%2BREBe75iwOcNb%2FV8o1l8JLBh4Rel8EPC0rCM4Y8BqKa7Fp%2ByVIZmDsMc0ydU8Eqj008O%2FD%2B6G9xNWOmGcNJDNCBbMEWLvv4yde7XLALXp2TT%2FdT9FOtzs14pzMswMw%3D%3D&type={tracking_type}&rank={rank}&ts={ts}&clientName=Marriott Media Network&beaconIssued=2026-03-11T22:10:34Z',
        cpm: 0.5,
        bid: 100,
        bucket_id: -1,
        tracking_guid: '643395e3-518a-4660-833a-30f22f85fc34',
        assets: {
          altText: 'alt text 1',
          ctaURL: 'cat 1',
          primaryImage_mobile:
            'https://imagedelivery.net/IvUYdEnp2tRk9IGugpbDnQ/b85df611-fbe8-47a8-2b5b-1d9641e26500/public',
          primaryImage_mobile_description: '123',
          primaryImage_mobile_headline: 'headline',
          primaryImage_mobile_landing_page_url: 'https://www.marriott.com/offers.mi',
        },
        custom_output: {
          ad_group_id: 1506830,
          advertiser_id: 494503,
          campaign_id: 1519585,
          targeting: null,
        },
      },
    ],
    eVar48: null,
    impressionValue: 'popularOffersHomepage1,type=dca,msg=dca',
    analyticsName: null,
    metaTags: null,
    bullet1: null,
    bullet2: null,
    bullet3: null,
    callToActionText1: null,
    callToActionText2: null,
    caption: null,
    captionUrl: null,
    descriptionLong: null,
    descriptionMedium: null,
    descriptionShort: null,
    destinationUrl1: null,
    destinationUrl2: null,
    eyebrowText: null,
    headerLong: null,
    headerMedium: null,
    headerShort: null,
    image: null,
    imageAssetId: null,
    legalLong: null,
    legalShort: null,
    localeOfContent: 'en_US',
    logo: null,
    tertiaryImage: null,
    logoAssetId: null,
    mathLabel1: null,
    mathLabel2: null,
    mathLabel3: null,
    mathTitle: null,
    mathType: null,
    mathValue: null,
    mboxName: 'popularOffersHomepage1-mbox',
    metadata: {
      experienceName: 'Web',
      isMango: true,
    },
    promotionalTag: null,
    responseTokens: {
      'activity.name': 'Polaris|PopularOffersHomepage1-mbox|Test',
      'geo.state': 'virginia',
      'activity.id': '132402',
      'experience.name': 'Variant',
      'option.name': 'MangoDCA2',
      'option.id': '2',
      'geo.ispName': 'netskope inc.',
      'geo.mobileCarrier': 'none',
      'geo.country': 'united states',
      'profile.activeActivities': '132402,132305,132343,132404,129675,129674,129677,129676,129679,129678,132237',
      'offer.id': '410079',
      'experience.id': '1',
      'geo.city': 'ashburn',
      'offer.name': 'MangoDCA2',
    },
    __typename: 'DCADynamicContentMbox',
  },
};
